module.exports = __webpack_public_path__ + "assets/img/1161587028263_.pic_hd.ff131edf.jpg";